import { render, staticRenderFns } from "./ButtonPreviewAudio.vue?vue&type=template&id=787b33cc&scoped=true&"
import script from "./ButtonPreviewAudio.vue?vue&type=script&lang=js&"
export * from "./ButtonPreviewAudio.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPreviewAudio.vue?vue&type=style&index=0&id=787b33cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b33cc",
  null
  
)

export default component.exports